import moment from "moment";
import update from "immutability-helper";
import axios from "axios";

export function onFocus() {
  if (new Date().getTime() - this.state.loadedAt >= 0.5 * 60 * 1000) {
    this.displayDocs(this.state.query, null, true);
  }
}

export function clearDocs() {
  this.setState({
    lastDocNum: null,
    documents: [],
  });
}

export function clearSearch() {
  this.setState(
    {
      lastDocNum: null,
      documents: [],
      query: "",
      Search: "",
    },
    () => {
      this.displayDocs(this.state.query);
    }
  );
}

export function clearFilters(filter) {
  if (filter === "query") {
    this.clearSearch();
    return;
  }

  if (filter.startsWith("show")) {
    this.setState(
      {
        lastDocNum: null,
        documents: [],
        [filter]: false,
      },
      () => {
        this.displayDocs(this.state.query);
      }
    );
  }
}

export function displayDocs(query, reset, refresh) {
  // query the API and update the component state

  if (query) {
    query = query.trim();
  }

  if (query && !query.length) {
    this.setState({
      loading: false,
      searching: false,
    });
    return false;
  }

  this.setState(
    {
      query: query || "",
    },
    () => {
      // Build query parameters for API
      const params = {
        limit: refresh ? this.state.documents.length : this.state.limit,
        collection: this.props.collection,
      };

      // Add search query
      if (this.state.query && this.state.query.length) {
        params.search = this.state.query;
      }

      // Add status filters (supports multiple simultaneous filters)
      if (this.state.showApproved) {
        params.showApproved = true;
      }
      if (this.state.showSentToClient) {
        params.showSentToClient = true;
      }
      if (this.state.showRejected) {
        params.showRejected = true;
      }
      if (this.state.showRevised) {
        params.showRevised = true;
      }
      if (this.state.showActionNeeded) {
        params.showActionNeeded = true;
      }

      // Add pagination cursor
      if (this.state.lastDocNum && !reset && !refresh) {
        params.lastDocNum = this.state.lastDocNum;
      }

      // Fetch count and documents in parallel for better performance
      Promise.all([
        axios.get("/api/documents/count", { params }),
        axios.get("/api/documents", { params })
      ])
        .then(([countResponse, docsResponse]) => {
          const total = countResponse.data.count;
          const documents = docsResponse.data.documents;
          let updatedDocs;
          let noResults;

          if (reset || refresh) {
            updatedDocs = documents;
          } else {
            updatedDocs = update(this.state.documents, {
              $push: documents,
            });
          }

          if (documents.length) {
            noResults = false;
          } else {
            noResults = true;
          }

          this.setState(
            {
              total: total || 0,
              documents: updatedDocs,
              loading: false,
              noResults: noResults,
              searching: false,
              loadedAt: new Date().getTime(),
            },
            () => {
              if (this.state.documents.length) {
                this.setState({
                  lastDocNum: this.state.documents[
                    this.state.documents.length - 1
                  ].docNum,
                });
              }
              if (
                this.state.documents.length > this.state.limit &&
                !refresh
              ) {
                try {
                  let objDiv = document.querySelectorAll(
                    "#doc-list .doc"
                  )[this.state.documents.length - this.state.limit - 1];
                  objDiv.scrollIntoView();
                } catch (err) {}
              }
              localStorage.setItem(
                "sow-filters",
                JSON.stringify({
                  showApproved: this.state.showApproved,
                  showRejected: this.state.showRejected,
                  showRevised: this.state.showRevised,
                  showActionNeeded: this.state.showActionNeeded,
                  showSentToClient: this.state.showSentToClient,
                  query: this.state.query,
                })
              );
            }
          );
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
          this.setState({
            loading: false,
            searching: false,
          });
        });
    }
  );
}

export function loadMore() {
  this.setState(
    {
      loading: true,
      limit: this.state.limit,
      page: this.state.page + 1,
    },
    () => {
      this.displayDocs(this.state.query);
    }
  );
}

export function displayDocsOnLoad() {
  if (localStorage.getItem("sow-filters")) {
    this.setState(
      {
        Search: JSON.parse(localStorage.getItem("sow-filters")).query,
        showApproved: JSON.parse(localStorage.getItem("sow-filters"))
          .showApproved,
        showRejected: JSON.parse(localStorage.getItem("sow-filters"))
          .showRejected,
        showRevised: JSON.parse(localStorage.getItem("sow-filters"))
          .showRevised,
        showSentToClient: JSON.parse(localStorage.getItem("sow-filters"))
          .showSentToClient,
        showActionNeeded: JSON.parse(localStorage.getItem("sow-filters"))
          .showActionNeeded,
      },
      () => {
        this.displayDocs(this.state.Search);
      }
    );
  } else {
    this.displayDocs();
  }
}

export function addDoc(state) {
  console.log("add", state, this.context.user);
  this.setState(
    {
      adding: true,
    },
    () => {
      const {
        newCrmCompany,
        newCompany,
        newType,
        newQuarter,
        newYear,
        newCustom,
      } = state;
      if ((newCrmCompany || newCompany.trim()) && newType) {
        let generatedName = this.generateDocName(
          (newCrmCompany && newCrmCompany.label) || newCompany,
          newType,
          newQuarter,
          newCustom,
          newYear
        );

        this.getNewDocNumber().then((newNum) => {
          const newDoc = {
            createdBy: this.context.user.id,
            docNum: newNum,
            Title: `${newNum}_${generatedName}`,
            crmCompany:
              newCrmCompany && newCrmCompany.label ? newCrmCompany : null,
            company: (newCrmCompany && newCrmCompany.label) || newCompany,
            type: newType,
            quarter: newQuarter,
            custom: newCustom,
            year: newYear,
            date: moment().toDate(),
            sigDate: moment().toDate(),
            version: 1,
            collection: this.props.collection,
          };

          axios
            .post("/api/documents", newDoc)
            .then((response) => {
              this.setState(
                {
                  adding: false,
                },
                () => {
                  this.props.history.push(`/${response.data.insertedId}`);
                }
              );
            })
            .catch((error) => {
              console.error("Error creating document:", error);
              this.setState({ adding: false });
            });
        });
      }
    }
  );
}

export function enableSearching() {
  this.setState({
    searching: true,
  });
}

export function pageChanged(e) {
  if (e.target.text) {
    this.setState(
      {
        page: parseInt(e.target.text, 10),
      },
      () => {
        this.displayDocs(this.state.query);
      }
    );
  }
}

export async function fetchTeam() {
  try {
    const response = await axios.get("/api/members");
    this.setState({
      members: response.data,
    });
  } catch (error) {
    console.error("Error fetching team:", error);
  }
}
